import { supabase } from '@/supabase'

export interface CardRefuelTransaction {
  id?: string;
  vehicle_id: string;
  trailer_id?: string | null;
  driver_id: string;
  odometer: number;
  pump_price: number;
  truck_volume: number;
  trailer_volume: number;
  total_volume: number;
  total_amount: number;
  actual_card_value: number;
  discrepancy: number;
  date: string;
  notes?: string;
  voucher_reference?: string | null;
  voucher_photo_url?: string | null;
  slip_photo_url?: string | null;
  created_at?: string;
}

export const cardRefuelService = {
  async createCardRefuel(refuel: CardRefuelTransaction) {
    const { data, error } = await supabase
      .from('card_refuel_transactions')
      .insert([
        refuel
      ])
      .select()
      .single()
    if (error) throw error
    return data
  },
  async getCardRefuels(params: { vehicle_id?: string; driver_id?: string; from?: string; to?: string } = {}) {
    let query = supabase.from('card_refuel_transactions').select('*')
    if (params.vehicle_id) query = query.eq('vehicle_id', params.vehicle_id)
    if (params.driver_id) query = query.eq('driver_id', params.driver_id)
    if (params.from) query = query.gte('date', params.from)
    if (params.to) query = query.lte('date', params.to)
    const { data, error } = await query.order('date', { ascending: false })
    if (error) throw error
    return data
  },
  async updateCardRefuel(id: string, refuel: CardRefuelTransaction) {
    const { data, error } = await supabase
      .from('card_refuel_transactions')
      .update(refuel)
      .eq('id', id)
      .select()
      .single()
    if (error) throw error
    return data
  },
  async deleteCardRefuel(id: string) {
    const { error } = await supabase
      .from('card_refuel_transactions')
      .delete()
      .eq('id', id)
    if (error) throw error
  }
}
